import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class TheatrePatientServices implements IDataStorage {
  Index: InternalIndex = new InternalIndex(
    'TheatrePatientId',
    'TheatrePatientId',
    false,
    false
  );
  tableDefinition: InternalTable = new InternalTable(
    'TheatrePatientServices',
    'Id',
    true,
    [this.Index]
  );

  Id: number;
  TheatrePatientId: number;
  ServiceId: number;
  Quantity: number;
  OriginalQuantity: number;
  Name: string;
  UnitOfMeasure: string;
  Barcode: string;
  InstitutionId: number;
  PackBasketId: string;
  PackId: number;
  Username: string;

  static getTableDefinition(): InternalTable {
    return new TheatrePatientServices().tableDefinition;
  }
}
